import React from 'react'
import { default as EB } from 'react-error-boundary'
import styled from 'styled-components'
import { reportException } from '../../utils/posthog'
// import { sendDiscordError } from '../../utils'

const ErrorContainer = styled.div`
  width: 100%;
  font-family: hind;
  font-weight: 300;
  color: #f44336;
  font-size: 16px;
  margin-bottom: 20px;
`

const ErrorBoundary = ({children}) => {
  const errorHandler = (error, componentStack) => {
    console.log(error, componentStack)
    // STY-445: report render-phase errors to PostHog. capture_exceptions only hooks
    // window.onerror / unhandledrejection; React swallows render-phase errors, so they need explicit
    // capture. reportException buffers the error if PostHog hasn't finished loading (init waits on
    // ensureGeoResolved + the async array.js load) and flushes once ready, so a startup render crash
    // isn't dropped. (Codex P2 #85.) PostHog is consent-free; reportException never throws.
    reportException(error, { component_stack: componentStack })
    // sendDiscordError('Submissions Server', error, componentStack)
  }

  const fallbackComponent = ({ componentsStack, error }) => (
    <ErrorContainer>There seems to be an issue with this component. Our tech staff has been notified.</ErrorContainer>
  )

  return (
    <EB onError={errorHandler} FallbackComponent={fallbackComponent}>
      {children}
    </EB>
  )
}

export default ErrorBoundary
